import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MathCaptcha from "../../Components/UI/MathCaptcha";

const Registeruser = () => {
  const [resident_name, setResident_name] = useState("");
  const [storage_type, setStorage_type] = useState("");
  const [resident_type, setResident_type] = useState("");

  const [email, setEmail] = useState(""); // This is the email
  const [mobileno, setMobileno] = useState("");
  const [villa_no, setvilla_no] = useState("");
  // const [confirmpassword, setConfirmpassword] = useState("");

  const [isVerified, setIsVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for submitting
  const [resetCaptcha, setResetCaptcha] = useState(false);

  useEffect(() => {
    if (resetCaptcha) {
      setResetCaptcha(false); // Clear the reset state after it has been used
    }
  }, [resetCaptcha]);

  const [showMessage, setShowMessage] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [message, setMessage] = useState("");
  const showMessageWithType = (type, msg) => {
    setMessageType(type);
    setMessage(msg);
    setShowMessage(true);
  };

  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 10000); // Display message for 10 seconds
      return () => clearTimeout(timer);
    }
  }, [showMessage]);

  const Required = () => <span style={{ color: "red" }}>*</span>;

  // Allows letters & Number but no spaces,
  const validateVillaNo = (villa_no) => {
    const villaRegex = /^[A-Za-z0-9]+$/; // only letters and numbers, no spaces
    return villaRegex.test(villa_no);
  };

  // Allows only letters and single spaces between words; length 3–80 characters
  const validateresident_name = (name) => {
    const resident_nameRegex = /^[A-Za-z]+(?:\s[A-Za-z]+)*$/;
    return (
      resident_nameRegex.test(name.trim()) &&
      name.trim().length >= 3 &&
      name.trim().length <= 80
    );
  };

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Mobile number validation function
  const validateMobileNumber = (mobileno) => {
    const mobileRegex = /^[6-9]\d{9}$/;
    return mobileRegex.test(mobileno);
  };
  const registeruser = useRef(null);
  const resetForm = () => {
    // registeruser.current.reset();
    setvilla_no("");
    setResident_name("");
    setEmail("");
    setResident_type("");
    setStorage_type("");
    setMobileno("");
    setIsSubmitting(false);
    setIsVerified(false);
    setResetCaptcha(true);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent multiple submissions
    setIsSubmitting(true); // Set submitting state

    const trimmedVilla = villa_no.trim();
    const trimmedName = resident_name.trim();
    const trimmedEmail = email.trim();
    const trimmedMobile = mobileno.trim();
    const trimmedStorage = storage_type.trim();
    const trimmedResidentType = resident_type.trim();

    // Client-side validations
    if (
      !trimmedVilla ||
      !trimmedName ||
      !trimmedStorage ||
      !trimmedEmail ||
      !trimmedResidentType ||
      !trimmedMobile
    ) {
      showMessageWithType(
        "error",
        "Please fill all required fields.(कृपया सभी आवश्यक जानकारी भरें)"
      );
      setIsSubmitting(false);
      return;
    }
    //1
    if (!validateVillaNo(trimmedVilla)) {
      showMessageWithType(
        "error",
        "Please enter a valid Villa/Plot No. (only letters and numbers, no spaces)."
      );
      setIsSubmitting(false);
      return;
    }
    //2
    if (!validateresident_name(trimmedName)) {
      showMessageWithType(
        "error",
        "Name can only contain letters and single spaces between words."
      );
      setIsSubmitting(false);
      return;
    }
    //3
    if (!validateEmail(trimmedEmail)) {
      showMessageWithType("error", "Please enter a valid email.");
      setIsSubmitting(false);
      return;
    }
    //4
    if (!validateMobileNumber(trimmedMobile)) {
      showMessageWithType(
        "error",
        "Please enter a valid 10-digit mobile number starting with 6-9."
      );
      setIsSubmitting(false);
      return;
    }
    //verify captcha
    if (!isVerified) {
      showMessageWithType("error", "Please complete the captcha");
      setIsSubmitting(false);
      return;
    }
    // call API  to register in Jal System
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/registerInJal`,
        {
          villa_no: trimmedVilla,
          resident_name: trimmedName,
          storage_type: trimmedStorage,
          email: trimmedEmail,
          resident_type: trimmedResidentType,
          mobile: trimmedMobile,
        }
      );
      if (response.status === 200 && response.data.status === "success") {
        showMessageWithType(
          response.data.status,
          response.data.message || "Registered successfully!"
        );
        resetForm();
      } else {
        showMessageWithType(response.data.status, response.data.message);
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Something went wrong, try again later.";
      showMessageWithType("error", errorMessage);
    } finally {
      window.scrollTo({ top: 0, behavior: "smooth" }); // 👈 Scroll to top
      setResetCaptcha(true); // Reset captcha on error
      setIsSubmitting(false); // Reset submitting state
    }
  };

  return (
    <div className="container">
      <div className="admin-wrap">
        <div className="box-head">
          <span>Water Supply Registration</span>
        </div>
        <form
          name="registeruser"
          className="login-form"
          onSubmit={handleSubmit}
          ref={registeruser}
        >
          {showMessage && (
            <p className={`${messageType} ${!showMessage && "hidden"}`}>
              {message}
            </p>
          )}
          <div className="form-group">
            <label
              htmlFor="resident_name"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Resident Name (निवासी का नाम)
              <Required />
            </label>
            <input
              id="resident_name"
              type="text"
              name="resident_name"
              autoComplete="name"
              required
              placeholder="Resident Name"
              value={resident_name}
              onChange={(e) => setResident_name(e.target.value.toUpperCase())}
            />
          </div>
          <div className="form-group">
            <label
              htmlFor="villa_no"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Villa No./Plot No. (विला नंबर / प्लाट नंबर)
              <Required />
            </label>
            <input
              id="villa_no"
              type="text"
              name="villa_no"
              autoComplete="villa_no"
              required
              placeholder="Villa / Plot No"
              value={villa_no}
              onChange={(e) => setvilla_no(e.target.value.toUpperCase())}
            />
          </div>
          <div className="form-group">
            <label
              htmlFor="storage_type"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Water Storage Type (जल संग्रहण प्रकार)
              <Required />
            </label>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="storage_type"
                  value="Underground"
                  style={{ cursor: "pointer" }}
                  checked={storage_type === "Underground"}
                  onChange={(e) => setStorage_type(e.target.value)}
                />
                <span>Underground</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="storage_type"
                  value="Overhead"
                  style={{ cursor: "pointer" }}
                  checked={storage_type === "Overhead"}
                  onChange={(e) => setStorage_type(e.target.value)}
                />
                <span>Overhead</span>
              </label>
            </div>
          </div>

          {/* Resident Type */}
          <div className="form-group" style={{ marginTop: "16px" }}>
            <label
              htmlFor="resident_type"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Resident Type(निवासी प्रकार)
              <Required />
            </label>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="resident_type"
                  value="Owner"
                  checked={resident_type === "Owner"}
                  onChange={(e) => setResident_type(e.target.value)}
                />
                <span>Owner</span>
              </label>

              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="resident_type"
                  value="Tenant"
                  checked={resident_type === "Tenant"}
                  onChange={(e) => setResident_type(e.target.value)}
                />
                <span>Tenant</span>
              </label>
            </div>
          </div>

          <div className="form-group">
            <label
              htmlFor="email"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Email Id (कृपया अपनी ईमेल आई डी उपलब्ध करवाएं)
              <Required />
            </label>
            <input
              id="email"
              type="email"
              name="email"
              autoComplete="email"
              required
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value.toLowerCase())}
            />
          </div>
          <div className="form-group">
            <label
              htmlFor="mobileno"
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              WhatsApp connected Mobile No.(अपना व्हाट्सप्प से जुड़ा मोबाइल नंबर
              दर्ज करें)
              <Required />
            </label>
            <input
              id="mobileno"
              type="text"
              name="mobileno"
              autoComplete="tel"
              placeholder="mobile no"
              required
              value={mobileno}
              onChange={(e) => {
                let value = e.target.value.replace(/\D/g, ""); // remove all non-digits
                if (value.length > 10) {
                  value = value.slice(-10); // keep only last 10 digits
                }
                setMobileno(value);
              }}
            />
          </div>
          <div
            className="form-group"
            style={{
              display: "block",
              fontWeight: "bold",
              marginBottom: "8px",
            }}
          >
            <MathCaptcha onVerification={setIsVerified} reset={resetCaptcha} />
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              className="readMoreButton"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Registeruser;
